import { buildStars } from 'Functions/rating';
import { initTippy } from 'Functions/tippy';

import "Layouts/default";

import 'Ui/slider';

buildStars()

initTippy('.js-product-banner-tooltip', {
    theme: 'banner-tooltip',
    placement: 'top-start',
    arrow: false,
    trigger: 'click',
    popperOptions: {
        modifiers: [{
            name: 'flip',
            options: {
                fallbackPlacements: ['top-end']
            },
        }],
    },
})

if (document.querySelector('.js-product-banner-tooltip')) {
    const tooltips = document.querySelectorAll('.js-product-banner-tooltip')

    for (let i = 0; i < tooltips.length; i++) {
        const tooltip = tooltips[i];

        setTimeout(() => {
            tooltip.classList.add('is-animatable')
        }, 200 * i % 3600);
    }
}

